// Import des traductions communes
import frCommon from './fr/common.json';
import enCommon from './en/common.json';

export type Language = 'fr' | 'en';

// Traductions communes (partagées entre toutes les pages)
export const commonTranslations = {
  fr: frCommon,
  en: enCommon,
};

export const defaultLanguage: Language = 'fr';

export const availableLanguages: { code: Language; name: string; flag: string }[] = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
];

// Types de sections
export type TranslationSection = 'public' | 'game' | 'panel';

// Fonction pour charger dynamiquement une traduction de page
export const loadPageTranslation = async (
  lang: Language, 
  section: TranslationSection,
  page: string
): Promise<any> => {
  try {
    // Import dynamique selon la langue, la section et la page
    switch (lang) {
      case 'fr':
        switch (section) {
          case 'public':
            switch (page) {
              case 'Home':
                return (await import('./fr/public/Home.json')).default;
              case 'LoginModal':
                return (await import('./fr/public/LoginModal.json')).default;
              case 'SignupModal':
                return (await import('./fr/public/SignupModal.json')).default;
              case 'Aide':
                return (await import('./fr/public/Aide.json')).default;
              case 'FAQ':
                return (await import('./fr/public/FAQ.json')).default;
              case 'Contact':
                return (await import('./fr/public/Contact.json')).default;
              case 'Changelog':
                return (await import('./fr/public/Changelog.json')).default;
              case 'MentionsLegales':
                return (await import('./fr/public/MentionsLegales.json')).default;
              case 'ConditionsUtilisation':
                return (await import('./fr/public/ConditionsUtilisation.json')).default;
              case 'PolitiqueConfidentialite':
                return (await import('./fr/public/PolitiqueConfidentialite.json')).default;
              case 'Reglement':
                return (await import('./fr/public/Reglement.json')).default;
              case 'ReglementSanctions':
                return (await import('./fr/public/ReglementSanctions.json')).default;
              default:
                return {};
            }
          case 'game':
            switch (page) {
              case 'Dashboard':
                return (await import('./fr/game/Dashboard.json')).default;
              case 'DashboardHeader':
                return (await import('./fr/game/DashboardHeader.json')).default;
              case 'SupportModal':
                return (await import('./fr/game/SupportModal.json')).default;
              case 'SettingsModal':
                return (await import('./fr/game/SettingsModal.json')).default;
              case 'GameModeSelector':
                return (await import('./fr/game/GameModeSelector.json')).default;
              case 'GameOptions':
                return (await import('./fr/game/GameOptions.json')).default;
              case 'CallCenterStatus':
                return (await import('./fr/game/CallCenterStatus.json')).default;
              case 'ManagementModeStatus':
                return (await import('./fr/game/ManagementModeStatus.json')).default;
              case 'StatsSection':
                return (await import('./fr/game/StatsSection.json')).default;
              case 'ActivationConfirmModal':
                return (await import('./fr/game/ActivationConfirmModal.json')).default;
              case 'LoadingScreen':
                return (await import('./fr/game/LoadingScreen.json')).default;
              case 'NavbarServerTime':
                return (await import('./fr/game/NavbarServerTime.json')).default;
              case 'Map':
                return (await import('./fr/game/Map.json')).default;
              case 'AlliancePage':
                return (await import('./fr/game/AlliancePage.json')).default;
              case 'GuidedTutorial':
                return (await import('./fr/game/GuidedTutorial.json')).default;
              default:
                return {};
            }
          case 'panel':
            switch (page) {
              case 'Panel':
                return (await import('./fr/panel/Panel.json')).default;
              case 'UserRolesManagement':
                return (await import('./fr/panel/UserRolesManagement.json')).default;
              case 'UsersManagement':
                return (await import('./fr/panel/UsersManagement.json')).default;
              case 'SystemConfiguration':
                return (await import('./fr/panel/SystemConfiguration.json')).default;
              case 'TeamSupport':
                return (await import('./fr/panel/TeamSupport.json')).default;
              default:
                return {};
            }
          default:
            return {};
        }
      case 'en':
        switch (section) {
          case 'public':
            switch (page) {
              case 'Home':
                return (await import('./en/public/Home.json')).default;
              case 'LoginModal':
                return (await import('./en/public/LoginModal.json')).default;
              case 'SignupModal':
                return (await import('./en/public/SignupModal.json')).default;
              case 'Aide':
                return (await import('./en/public/Aide.json')).default;
              case 'FAQ':
                return (await import('./en/public/FAQ.json')).default;
              case 'Contact':
                return (await import('./en/public/Contact.json')).default;
              case 'Changelog':
                return (await import('./en/public/Changelog.json')).default;
              case 'MentionsLegales':
                return (await import('./en/public/MentionsLegales.json')).default;
              case 'ConditionsUtilisation':
                return (await import('./en/public/ConditionsUtilisation.json')).default;
              case 'PolitiqueConfidentialite':
                return (await import('./en/public/PolitiqueConfidentialite.json')).default;
              case 'Reglement':
                return (await import('./en/public/Reglement.json')).default;
              case 'ReglementSanctions':
                return (await import('./en/public/ReglementSanctions.json')).default;
              default:
                return {};
            }
          case 'game':
            switch (page) {
              case 'Dashboard':
                return (await import('./en/game/Dashboard.json')).default;
              case 'DashboardHeader':
                return (await import('./en/game/DashboardHeader.json')).default;
              case 'SupportModal':
                return (await import('./en/game/SupportModal.json')).default;
              case 'SettingsModal':
                return (await import('./en/game/SettingsModal.json')).default;
              case 'GameModeSelector':
                return (await import('./en/game/GameModeSelector.json')).default;
              case 'GameOptions':
                return (await import('./en/game/GameOptions.json')).default;
              case 'CallCenterStatus':
                return (await import('./en/game/CallCenterStatus.json')).default;
              case 'ManagementModeStatus':
                return (await import('./en/game/ManagementModeStatus.json')).default;
              case 'StatsSection':
                return (await import('./en/game/StatsSection.json')).default;
              case 'ActivationConfirmModal':
                return (await import('./en/game/ActivationConfirmModal.json')).default;
              case 'LoadingScreen':
                return (await import('./en/game/LoadingScreen.json')).default;
              case 'NavbarServerTime':
                return (await import('./en/game/NavbarServerTime.json')).default;
              case 'Map':
                return (await import('./en/game/Map.json')).default;
              case 'AlliancePage':
                return (await import('./en/game/AlliancePage.json')).default;
              case 'GuidedTutorial':
                return (await import('./en/game/GuidedTutorial.json')).default;
              default:
                return {};
            }
          case 'panel':
            switch (page) {
              case 'Panel':
                return (await import('./en/panel/Panel.json')).default;
              case 'UserRolesManagement':
                return (await import('./en/panel/UserRolesManagement.json')).default;
              case 'UsersManagement':
                return (await import('./en/panel/UsersManagement.json')).default;
              case 'SystemConfiguration':
                return (await import('./en/panel/SystemConfiguration.json')).default;
              case 'TeamSupport':
                return (await import('./en/panel/TeamSupport.json')).default;
              default:
                return {};
            }
          default:
            return {};
        }
      default:
        return {};
    }
  } catch (error) {
    console.warn(`Translation file not found: ${lang}/${section}/${page}.json`, error);
    return {};
  }
};
